/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

export enum PanelEvent {
   HIDE,
   SHOW,
   TOGGLE
}

export const PROTOCOL_MISMATCH_ERROR_CODE = "AGENT_ERR_PROTOCOL_FAMILY_MISMATCH";
export const PROTOCOL_ERROR = "Please try connecting via another protocol or logoff the existing session first";
